// @flow
import React, { Component } from "react";
import Landing from "../components/Landing/Landing";

type Props = {
  data: {
    breaches: {
      edges: Array<{ node: PrismicBreach }>
    }
  }
};

class IndexPage extends Component<Props, void> {
  render() {
    return <Landing {...this.props} />;
  }
}

export default IndexPage;

export const pageQuery = graphql`
  query IndexQuery {
    breaches: allPrismicBreach(
      sort: { fields: [data___disclosed_at], order: DESC }
    ) {
      edges {
        node {
          uid
          data {
            title {
              text
            }
            company_name
            company_url {
              url
            }
            disclosed_at
            attack_vector
            severity
            location {
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js